import {HStack, Link, Show, Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetUserQuery} from '@dms/api/customer';
import {CarVerticalReportResponseBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';
import {getNaturalPersonFullName} from '@dms/shared';

import {parseDate, TestIdProps} from 'shared/web';

interface CarVerticalLineProps extends TestIdProps {
  report: CarVerticalReportResponseBody;
}

export function CarVerticalLine(props: CarVerticalLineProps) {
  const formatDateTime = useDateTimeFormatter();
  const {data: user} = useGetUserQuery({id: props.report.createdBy});

  const userFullName = getNaturalPersonFullName(user);

  return (
    <HStack spacing={3} align="center">
      <Link
        href={props.report.url}
        title={i18n.t('page.integrations.labels.carVerticalPreviousReport', {
          date: formatDateTime('dateShort', parseDate(props.report.createdAt)),
        })}
        isDisabled={props.report.status !== 'finished'}
        rightIcon="action/open_in_new"
        size="small"
        target="_blank"
      />
      <Show when={isNotNilOrEmpty(userFullName)}>
        <Text size="xSmall" color="tertiary">
          {userFullName}
        </Text>
      </Show>
    </HStack>
  );
}
